module.exports = __webpack_public_path__ + "img/benoit25.49b2f742.jpg";